import { runtimeEnv } from "./runtime-config";
/**
 * Platform-staff derivation (SYN-1504).
 *
 * Platform staff = a user holding a real membership in the SynapseDx Clerk
 * org. The org id comes from VITE_PLATFORM_STAFF_ORG_ID; when unset, NOBODY
 * is staff (fail closed). Engine links (Atlas, ISAAC, Coherence, Memory) and
 * the Sites menu render only for staff.
 *
 * This is presentation gating only — the engine UIs keep enforcing their own
 * server-side auth regardless (defense in depth), and the BFF re-validates
 * the staff claim server-side (src/auth/platform-staff.ts) for any staff-only
 * data it serves.
 */

/**
 * Read the SynapseDx (platform staff) Clerk org id from Vite env.
 * Returns null when unset or blank — which means nobody is staff.
 */
export function getPlatformStaffOrgId(): string | null {
  const value = runtimeEnv("VITE_PLATFORM_STAFF_ORG_ID") as unknown;
  if (typeof value === "string" && value.trim().length > 0) {
    return value.trim();
  }
  return null;
}

/**
 * Pure derivation: staff iff the configured staff org id is present in the
 * user's membership org ids. Fail closed on missing config.
 */
export function derivePlatformStaff(
  membershipOrgIds: readonly string[],
  staffOrgId: string | null,
): boolean {
  if (!staffOrgId) {
    return false;
  }
  return membershipOrgIds.includes(staffOrgId);
}
